import { useState } from 'react';

export type SearchParams = {
	search?: string;
	perPage?: number;
	page: number;
};

const initialValues: SearchParams = {
	search: undefined,
	perPage: 20,
	page: 1,
};

export const useCustomSearchParams = (): {
	searchQueries: SearchParams;
	changeSearchQueries: (searchParams: Partial<SearchParams>) => void;
	resetSearchQueries: () => void;
} => {
	const [searchQueries, setSearchParams] = useState<SearchParams>(initialValues);

	const changeSearchQueries = (searchParams: Partial<SearchParams>) =>
		setSearchParams((prev) => ({ ...prev, ...searchParams }));

	const resetSearchQueries = () => setSearchParams(initialValues);

	return {
		searchQueries,
		changeSearchQueries,
		resetSearchQueries,
	};
};
